import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../logo.png';
import fleur from '../fleur.png';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useResponsive } from '../hooks/useResponsive';

const NAV_ITEMS = [
    { label: 'Accueil', path: '/' },
    { label: 'À propos', path: '/about' },
    { label: 'Fonctionnalités', path: '/fonctionnalites' },
    { label: 'Comment ça marche', path: '/comment' },
    { label: 'Contact', path: '/contact' },
];

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const { isMobile, isTablet } = useResponsive();

    // Détermine l'onglet actif selon l'URL courante
    const isActive = (path) => location.pathname === path;

    return (
        <>
            <nav style={{
                ...styles.navbar,
                height: isMobile ? '110px' : '82px',
                padding: isMobile ? '0 16px' : isTablet ? '0 24px' : '0 48px',
                backgroundImage: isMobile ? 'none' : `url(${fleur})`,
                backgroundSize: 'auto 120%',
                backgroundPosition: 'left center',
                backgroundRepeat: 'no-repeat',
                justifyContent: isMobile ? 'center' : 'space-between',
            }}>
                <img src={logo} alt="Zawaj Tawadud" style={{
                    ...styles.navLogo,
                    height: isMobile ? '100px' : isTablet ? '70px' : '70px',
                    width: 'auto',
                    maxWidth: isMobile ? '75%' : 'none',
                    objectFit: 'contain',
                    marginTop: 0,
                    marginLeft: isMobile ? '0' : isTablet ? '40px' : '50px',
                }} />

                {isMobile ? (
                    <button onClick={() => setMenuOpen(!menuOpen)} style={{ ...styles.burgerBtn, position: 'absolute', right: '16px' }}>
                        {menuOpen ? <FaTimes color="white" size={24} /> : <FaBars color="white" size={24} />}
                    </button>
                ) : (
                    <>
                        <div style={{ ...styles.navCenter, gap: isTablet ? '14px' : '28px' }}>
                            {NAV_ITEMS.map((item, i) => (
                                <a key={i} href="#" title={item.label} onClick={(e) => { e.preventDefault(); navigate(item.path); }} style={{
                                    ...styles.navLink,
                                    fontSize: isTablet ? '12px' : '14px',
                                    color: isActive(item.path) ? 'white' : 'rgba(255,255,255,0.75)',
                                    borderBottom: isActive(item.path) ? '2px solid white' : '2px solid transparent',
                                    paddingBottom: '4px',
                                }}>{item.label}</a>
                            ))}
                        </div>
                        <div style={{ ...styles.navButtons, gap: isTablet ? '8px' : '12px' }}>
                            <button onClick={() => navigate('/login')} title="Se connecter" style={{
                                ...(isActive('/login') ? styles.tabActive : styles.tab),
                                padding: isTablet ? '6px 10px' : '8px 18px',
                                fontSize: isTablet ? '12px' : '14px'
                            }}>Se connecter</button>
                            <button onClick={() => navigate('/register')} title="Créer un compte" style={{
                                ...(isActive('/register') ? styles.tabActive : styles.tab),
                                padding: isTablet ? '6px 10px' : '8px 18px',
                                fontSize: isTablet ? '12px' : '14px'
                            }}>Créer un compte</button>
                        </div>
                    </>
                )}
            </nav>

            {isMobile && menuOpen && (
                <div style={styles.mobileMenu}>
                    {NAV_ITEMS.map((item, i) => (
                        <a key={i} href="#" title={item.label} style={styles.mobileNavLink} onClick={(e) => {
                            e.preventDefault();
                            setMenuOpen(false);
                            navigate(item.path);
                        }}>{item.label}</a>
                    ))}
                    <button onClick={() => { navigate('/login'); setMenuOpen(false); }} title="Se connecter" style={styles.mobileMenuBtn}>Se connecter</button>
                    <button onClick={() => { navigate('/register'); setMenuOpen(false); }} title="Créer un compte" style={{ ...styles.mobileMenuBtn, backgroundColor: '#c0306a' }}>Créer un compte</button>
                </div>
            )}
        </>
    );
};

const styles = {
    navbar: {
        height: '100px', overflow: 'hidden',
        display: 'flex', alignItems: 'center',
        position: 'sticky', top: 0, zIndex: 100,
        boxShadow: '0 2px 10px rgba(0,0,0,0.4)',
        backgroundColor: '#4a0028',
    },
    navLogo: { width: 'auto' },
    burgerBtn: { background: 'transparent', border: 'none', cursor: 'pointer', padding: '8px', zIndex: 10 },
    mobileMenu: { position: 'fixed', top: '72px', left: 0, right: 0, backgroundColor: '#1a0010', display: 'flex', flexDirection: 'column', padding: '16px', gap: '8px', zIndex: 200 },
    mobileNavLink: { color: 'rgba(255,255,255,0.85)', textDecoration: 'none', padding: '12px 0', fontSize: '15px', borderBottom: '1px solid rgba(255,255,255,0.08)' },
    mobileMenuBtn: { padding: '12px', backgroundColor: 'rgba(255,255,255,0.1)', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '700', fontSize: '15px', marginTop: '4px' },
    navCenter: { display: 'flex', alignItems: 'center' },
    navLink: { textDecoration: 'none', fontWeight: '500' },
    navButtons: { display: 'flex' },
    tab: {
        position: 'relative',
        padding: '8px 16px',
        backgroundColor: 'transparent',
        color: 'white',
        border: '1px solid rgba(255,255,255,0.35)',
        borderRadius: '6px',
        cursor: 'pointer',
        fontWeight: '500',
    },
    tabActive: {
        position: 'relative',
        padding: '8px 16px',
        backgroundColor: '#2a0014',
        color: 'white',
        border: '1px solid white',
        borderRadius: '6px',
        cursor: 'pointer',
        fontWeight: '700',
    },
};

const navbarStyles = styles;
export default Navbar;